export enum PfsGameType {
  SLOT = 'S',
  INSTANT = 'I',
  TABLE = 'T',
  PMR_SLOT = 'PMRS',
  PMR_TABLE = 'PMRT',
}

export const pfsGameTypeOptions = new Map<PfsGameType, string>([
  [PfsGameType.SLOT, 'Slot'],
  [PfsGameType.INSTANT, 'Instant'],
  [PfsGameType.TABLE, 'Table'],
  [PfsGameType.PMR_SLOT, 'PMR Slot'],
  [PfsGameType.PMR_TABLE, 'PRM Table'],
]);
